import { render, staticRenderFns } from "./RequirementReportList.vue?vue&type=template&id=28fc42d8&scoped=true"
import script from "./RequirementReportList.vue?vue&type=script&lang=js"
export * from "./RequirementReportList.vue?vue&type=script&lang=js"
import style0 from "./RequirementReportList.vue?vue&type=style&index=0&id=28fc42d8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fc42d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28fc42d8')) {
      api.createRecord('28fc42d8', component.options)
    } else {
      api.reload('28fc42d8', component.options)
    }
    module.hot.accept("./RequirementReportList.vue?vue&type=template&id=28fc42d8&scoped=true", function () {
      api.rerender('28fc42d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/RequirementReportList.vue"
export default component.exports